var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { useInput } from '../common/use-input';
export function useAccountTransfer() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser;
    var searchQuery = useInput('');
    var _b = useState([]), linkedAccounts = _b[0], setLinkedAccounts = _b[1];
    var _c = useState([]), displayedLinkedAccounts = _c[0], setDisplayedLinkedAccounts = _c[1];
    var _d = useState(undefined), transferInfo = _d[0], setTransferInfo = _d[1];
    var _e = useState(undefined), selectedLinkedAccount = _e[0], setSelectedLinkedAccount = _e[1];
    var _f = useState(false), showLinkedAccountsDialog = _f[0], setShowLinkedAccountsDialog = _f[1];
    var _g = useState(false), showConfirmDialog = _g[0], setShowConfirmDialog = _g[1];
    useEffect(function () {
        function getData() {
            return __awaiter(this, void 0, void 0, function () {
                var linkedAccountsResult, transferInfoResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setServerLoading(true);
                            return [4 /*yield*/, gqlSdk.UserListKycLinkedAccounts()];
                        case 1:
                            linkedAccountsResult = _a.sent();
                            return [4 /*yield*/, gqlSdk.UserGetTransferInfo()];
                        case 2:
                            transferInfoResult = _a.sent();
                            setLinkedAccounts(linkedAccountsResult.userListKycLinkedAccounts);
                            setDisplayedLinkedAccounts(linkedAccountsResult.userListKycLinkedAccounts);
                            setTransferInfo(transferInfoResult.userGetTransferInfo);
                            setServerLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (user) {
            getData();
        }
    }, [user]);
    useEffect(function () {
        var filteredAccounts = linkedAccounts.filter(function (account) { var _a; return (_a = account.username) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchQuery.value.toLowerCase()); });
        setDisplayedLinkedAccounts(searchQuery.value.length > 0 ? filteredAccounts : linkedAccounts);
    }, [linkedAccounts, searchQuery.value]);
    function transferAccount() {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedLinkedAccount)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.UserTransferAccount({ input: { toUserUuid: selectedLinkedAccount.uuid } })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, reconnectUser()];
                    case 2:
                        _a.sent();
                        setServerLoading(false);
                        setShowConfirmDialog(false);
                        setSelectedLinkedAccount(result.userTransferAccount ? undefined : selectedLinkedAccount);
                        setDialogProps({
                            common: {
                                title: !result.userTransferAccount.success ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: !result.userTransferAccount.success ? t('error.generic') : t('account-transfer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function selectLinkedAccount(value) {
        setSelectedLinkedAccount(value);
        setShowLinkedAccountsDialog(false);
    }
    return {
        searchQuery: searchQuery,
        displayedLinkedAccounts: displayedLinkedAccounts,
        transferInfo: transferInfo,
        selectedLinkedAccount: selectedLinkedAccount,
        showLinkedAccountsDialog: showLinkedAccountsDialog,
        showConfirmDialog: showConfirmDialog,
        selectLinkedAccount: selectLinkedAccount,
        transferAccount: transferAccount,
        setShowLinkedAccountsDialog: setShowLinkedAccountsDialog,
        setShowConfirmDialog: setShowConfirmDialog,
    };
}
